<template>
  <div>
    <v-card
      class="mx-auto mt-4 pr-2 hidden-md-and-down template-item"
      max-width="100%"
      outlined
    >
      <v-list-item three-line>
        <v-list-item-avatar tile size="110">
          <v-img
            v-if="template.ApplicationIconPath"
            :src="require(`@/assets/${template.ApplicationIconPath}`)"
          ></v-img>
          <v-img
            v-else-if="template.ProviderIconPath"
            :src="require(`@/assets/${template.ProviderIconPath}`)"
          ></v-img>
          <v-img v-else :src="require('@/assets/placeholder.png')"></v-img>
        </v-list-item-avatar>
        <div v-if="template.IsPublic" id="published-template-info">
          Published
        </div>
        <v-list-item-content>
          <div>
            <v-row class="ml-0">
              <div class="overline" id="iteration-style">
                Id: {{ template.Id }}
              </div>
              <div
                class="ml-8"
                id="template-name"
                v-if="sub !== template.OwnerSub"
              >
                <v-icon class="mr-2" small>far fa-share</v-icon>
                <span>Owner: {{ template.OwnerEmail }}</span>
              </div>
            </v-row>
          </div>
          <v-flex lg8>
            <v-list-item-title class="headline mb-2 title" id="title-style">
              {{ template.TemplateName }}
              <v-chip small outlined class="ml-2 info-chip">{{
                template.Type
              }}</v-chip>
            </v-list-item-title>
          </v-flex>

          <v-flex lg4 text-right>
            <v-btn
              class="text-none"
              :class="{
                'disabled-btn': template.Status !== 'available',
                'error-btn':
                  template.Status !== 'available' &&
                  template.Status !== 'pending',
              }"
              id="run-btn-style"
              :to="`/environments/${template.Id}/run`"
            >
              <div class="mt-1" v-if="template.Status === 'available'">
                <v-icon class="mb-1" left>fas fa-cloud-upload</v-icon>
                <span>Create</span>
              </div>
              <div class="mt-1" v-else-if="template.Status === 'pending'">
                <v-icon class="mb-1" small left>fas fa-spinner fa-spin</v-icon
                >Creating
              </div>
              <div v-else><v-icon left>fas fa-exclamation</v-icon>Error</div>
            </v-btn>
            <v-menu v-if="template.Status === 'available' || template.Status === 'failed'" nudge-bottom="45" nudge-left="100" class="dropdown-menu">
              <template v-slot:activator="{ on }">
                <v-btn class="mr-2 ml-6 dropdown" fab small v-on="on">
                  <v-icon color="#121212">fas fa-ellipsis-v</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  class="dropdown-item"
                  @click="showPublishUnpublishDialog = true"
                  v-if="(userGroups.includes('Administrators') || userGroups.includes('Publishers')) && template.Status === 'available'"
                >
                  <v-list-item-title>
                    <v-icon small left color="#6DB42C"
                      >fas fa-globe-europe</v-icon
                    >
                    {{
                      getPublicationAction.charAt(0).toUpperCase() +
                      getPublicationAction.slice(1)
                    }}
                    template
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  class="dropdown-item"
                  @click="showDeleteTemplateDialog = true"
                  :disabled="!template.AccessLevel && template.OwnerSub !== sub"
                >
                  <v-list-item-title>
                    <v-icon small left color="#6DB42C">far fa-trash-alt</v-icon
                    >Delete template
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  class="dropdown-item"
                  @click="onShare"
                  :disabled="!template.AccessLevel && template.OwnerSub !== sub"
                >
                  <v-list-item-title>
                    <v-icon small left color="#6DB42C">far fa-share</v-icon
                    >Share template
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-flex>

          <v-flex d-flex justify-start mt-4>
            <!-- <v-chip v-for="(tag, index) in template.tags" :key="tag" :class="{ 'ml-2': index > 0 }">{{ tag }}</v-chip> -->
            <v-chip>{{ template.ApplicationName }}</v-chip>
            <v-chip class="ml-2">{{ template.ApplicationProviderName }}</v-chip>
          </v-flex>
          <v-flex d-flex justify-end mt-4>
            <v-btn
              v-if="template.ReleaseNotes != 0"
              :href="template.ReleaseNotes"
              target="_blank"
              class="action-button"
              text
            >
              Release Notes
              <v-icon right id="icon-style">fas fa-external-link-alt</v-icon>
            </v-btn>
          </v-flex>
        </v-list-item-content>
      </v-list-item>
    </v-card>
    <PublishUnpublishDialog
      :showPublishUnpublishDialog.sync="showPublishUnpublishDialog"
      :templateId="template.Id"
      @confirmPublishUnpublishDialog="confirmPublishUnpublishDialog"
      @cancelPublishUnpublishDialog="cancelPublishUnpublishDialog"
      :action="getPublicationAction"
    />
    <DeleteTemplateDialog
      :showDeleteTemplateDialog.sync="showDeleteTemplateDialog"
      :templateId="template.Id"
      @confirmDeleteTemplateDialog="confirmDeleteTemplateDialog"
      @cancelDeleteTemplateDialog="cancelDeleteTemplateDialog"
    />
    <ShareTemplateDialog
      :showShareTemplateDialog.sync="showShareTemplateDialog"
      :templateId="template.Id"
      :users="users"
      :sharedTemplateWith="sharedTemplateWith"
      :shareBtnloading="shareBtnloading"
      @confirmShareTemplateDialog="confirmShareTemplateDialog"
      @cancelShareTemplateDialog="cancelShareTemplateDialog"
    />
    <v-overlay :value="shareModalLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import PublishUnpublishDialog from "../PublishUnpublishDialog";
import DeleteTemplateDialog from "../DeleteTemplate";
import ShareTemplateDialog from "../ShareTemplate";

import { mapGetters, mapActions } from "vuex";

export default {
  data: () => ({
    showPublishUnpublishDialog: false,
    showDeleteTemplateDialog: false,
    showShareTemplateDialog: false,
    shareBtnloading: false,
    shareModalLoading: false,
    refreshInterval: "",
  }),
  props: ["template"],
  components: {
    PublishUnpublishDialog,
    DeleteTemplateDialog,
    ShareTemplateDialog,
  },
  computed: {
    ...mapGetters([
      "templates",
      "userGroups",
      "sharedTemplateWith",
      "users",
      "sub",
      "connectedTemplateDetails",
    ]),
    getPublicationAction() {
      return this.template.IsPublic ? "unpublish" : "publish";
    },
  },
  methods: {
    ...mapActions([
      "publishUnpublishTemplate",
      "deleteTemplate",
      "shareTemplate",
      "getUserTemplates",
      "getUserSub",
      "getUsers",
      "getSharedTemplateWith",
      "shareConnectedTemplate",
      "stopSharingTemplate",
      "stopSharingConnectedTemplate",
      "getTemplates",
      "getConnectedTemplates",
      "getConnectedTemplateDetails",
    ]),
    async confirmPublishUnpublishDialog(data) {
      await this.publishUnpublishTemplate(data);
      this.showPublishUnpublishDialog = false;
    },
    cancelPublishUnpublishDialog() {
      this.showPublishUnpublishDialog = false;
    },
    async confirmDeleteTemplateDialog(id) {
      await this.deleteTemplate(id);
      this.showDeleteTemplateDialog = false;
    },
    cancelDeleteTemplateDialog() {
      this.showDeleteTemplateDialog = false;
    },
    async onShare() {
      this.shareModalLoading = true;
      if (this.template.ConnectedId)
        await this.getConnectedTemplateDetails(this.template.ConnectedId);
      await Promise.all([
        this.getUsers(),
        this.getSharedTemplateWith(
          this.template.ConnectedId
            ? this.connectedTemplateDetails.templates[0].TemplateId
            : this.template.Id
        ),
      ]);
      this.shareModalLoading = false;
      this.showShareTemplateDialog = !this.showShareTemplateDialog;
    },
    async confirmShareTemplateDialog(data) {
      this.shareBtnloading = true;
      if (data.addedMembers.length) {
        if (this.template.ConnectedId) {
          const params = {
            emails: data.addedMembers,
            connectedTemplateId: data.templateId,
          };
          await this.shareConnectedTemplate(params);
          await this.getConnectedTemplates();
        } else {
          data.emails = data.addedMembers;
          const { addedMembers, removedMembers, ...params } = data;
          await this.shareTemplate(params);
          await this.getTemplates();
        }
      }
      if (data.removedMembers.length) {
        if (this.template.ConnectedId) {
          const params = {
            emails: data.removedMembers,
            connectedTemplateId: data.templateId,
          };
          await this.stopSharingConnectedTemplate(params);
          await this.getConnectedTemplates();
        } else {
          data.emails = data.removedMembers;
          const { addedMembers, removedMembers, ...params } = data;
          await this.stopSharingTemplate(params);
          await this.getTemplates();
        }
      }
      this.showShareTemplateDialog = false;
      this.shareBtnloading = false;
    },
    cancelShareTemplateDialog() {
      this.showShareTemplateDialog = false;
    },
    async getPendingStates() {
      const pending = this.template.Status === "pending";
      if (pending) {
        await this.getUserTemplates();
      } else {
        clearInterval(this.refreshInterval);
        this.refreshInterval = "";
      }
    },
  },
  created() {
    if (!this.refreshInterval && this.template.Status === "pending") {
      this.refreshInterval = setInterval(
        () => this.getPendingStates(),
        30 * 1000
      );
    }
  },
  beforeDestroy() {
    clearInterval(this.refreshInterval);
  },
  beforeMount() {
    this.getUserSub();
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Montserrat&display=swap");

#published-template-info {
  padding: 5px;
  position: absolute;
  background-color: #6db42c;
  -ms-transform: rotate(-45deg); /* IE 9 */
  -ms-transform-origin: 0 190%;
  transform: rotate(-45deg);
  transform-origin: -3% 230%;
  width: 140px;
  font: 0.8em Montserrat;
  color: white;
  text-align: center;
}

.template-item {
  box-shadow: 0 0 14px -8px rgba(0, 0, 0, 0.4);
  border-radius: 20px;
  overflow: hidden;
}

div {
  font-family: "Montserrat";
}

.actions {
  background: #f9f9f9;
}

.card-actions,
.action-button {
  text-align: left;
  font: Regular 16px/19px Montserrat;
  letter-spacing: 0;
  color: #121212;
  opacity: 1;
  text-transform: none;
}

.action-button:nth-child(2) {
  padding: 0 5px !important;
}

#run-btn-style {
  background-color: #6db42c;
  font-size: 0.9em;
  border-radius: 16px;
  min-width: 103px;
  height: 35px;
  font: 15px/19px "Montserrat" !important;
  text-transform: none;
}

#icon-style {
  color: #d0398b;
}

#title-style {
  font: bold 16px/19px "Montserrat" !important;
  text-align: left;
}

#iteration-style {
  opacity: 1;
  color: #888888;
  text-align: left;
  font: 12px/15px "Montserrat" !important;
  letter-spacing: 0 !important;
}

.info-chip {
  color: #881e98;
  font-weight: bold;
  font-size: 0.7rem;
  border-color: #881e98 !important;
  height: 18.5px;
}

.dropdown {
  background: #eeeeee !important;
  box-shadow: none;
}

.dropdown-item:hover {
  background: #eeeeee;
  cursor: pointer;
}

.v-menu {
  z-index: 10000;
}

.disabled-btn {
  pointer-events: none;
}

.error-btn {
  background-color: red !important;
}
</style>